export default __webpack_public_path__ + "static/media/renDGB.2a113994.svg";